import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { DataTableSearch } from '@/common/ui/table/data-table-search'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import { UsageHistoryItem } from '../../type'
import { columns } from './constants'

interface UsageHistoryTableProps {
	data: UsageHistoryItem[]
	total: number
	isLoading?: boolean
}

export default function UsageHistoryTable({
	data,
	total,
	isLoading,
}: UsageHistoryTableProps) {
	return (
		<div className="space-y-4">
			<div className="flex items-center justify-between">
				<div className="flex flex-wrap items-center gap-4">
					<DataTableSearch placeHolder="ค้นหาด้วยเบอร์โทรผู้เล่น" />
					<DataTableResetFilter />
				</div>
			</div>
			<DataTablePaginate
				columns={columns}
				data={data}
				totalItems={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
